import { createContext, useContext } from 'react';
import { action, observable } from 'mobx';

type Optional<T> = {
  value: T;
  error: string;
};

const emptyValue = { error: '', value: '' };
class AdGroupBudget {
  @observable id = '';
  @observable isSubmitting = false;
  @observable editMode = false;

  @observable dailyBudget: Optional<string> = {
    value: '',
    error: ''
  };

  @observable factor: Optional<string> = {
    value: '',
    error: ''
  };

  @action init = (id: string, dailyBudget: number) => {
    this.editMode = true;
    this.dailyBudget.value = (dailyBudget / 100).toString();
    this.id = id ? id.toString() : '';
  };

  @action reset = () => {
    this.id = '';
    this.isSubmitting = false;
    this.editMode = false;
    this.dailyBudget = emptyValue;
    this.factor = emptyValue;
  };

  @action handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case 'dailyBudget':
        this.dailyBudget = {
          error: parseFloat(event.target.value) < 1 ? 'Budget must be higher than $1 or your ads may not deliver' : '',
          value: event.target.value.toString()
        };
        break;
      case 'budgetByFactor':
        this.factor = {
          error:
            parseFloat(event.target.value) > 5 || parseFloat(event.target.value) < 0.01
              ? 'Factor values should be between 0 and 5'
              : '',
          value: event.target.value
        };
        break;

      default:
        throw new Error('This field is not supported');
    }
  };

  validateBudgetInput(budget: number | null) {
    if (budget === 0) {
      return null;
    } else {
      return budget;
    }
  }
  @action getValuesBeforeUpdate = (ids: string[]) => {
    this.isSubmitting = true;
    return {
      googleAdGroupIds: ids,
      dailyBudget: Number(this.validateBudgetInput(Number(this.dailyBudget.value))) || null,
      factor: Number(this.factor.value) || null
    };
  };
}

export const AdGroupBudgetContext = createContext(new AdGroupBudget());

export const useAdGroupBudgetContext = () => useContext(AdGroupBudgetContext);

export default AdGroupBudget;
